import './aiServices.scss';
import Header from '../../src-utilities/header';
import '../../src-utilities/multipleBadges';
// import bestPractices from '../../src-utilities/bestPractices';
import './../../src-utilities/ourOffering';
import './../../src-utilities/footer';
import initAgile from './../../src-utilities/agile';
import './../../src-utilities/industries';
import Swiper from './../../../node_modules/swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

new Header();

gsap.registerPlugin(ScrollTrigger);

// our customer
new Swiper('.customers-logo', {
	modules: [Autoplay],
	slidesPerView: 6,
	loop: true,
	autoplay: {
		delay: 10,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 2000,
	breakpoints: {
		0: {
			spaceBetween: 15,
			slidesPerView: 3,
		},
		600: {
			slidesPerView: 5,
			spaceBetween: 30,
		},
	},
});

const initCapabilitiesSwiper = () => {
	const navSwiperEl = document.querySelector(
		'.capabilities-nav-wrapper .nav-swiper',
	);
	const contentSwiperEl = document.querySelector(
		'.capabilities-wrapper .content-swiper',
	);

	if (!navSwiperEl || !contentSwiperEl) return;

	const navTabs = document.querySelectorAll(
		'.capabilities-nav-wrapper .nav-tab',
	);

	const navSwiper = new Swiper(navSwiperEl, {
		slidesPerView: 'auto',
		spaceBetween: 8,
		watchSlidesProgress: true,
		slideToClickedSlide: true,
	});

	const contentSwiper = new Swiper(contentSwiperEl, {
		slideClass: 'tab-content-slide',
		slidesPerView: 1,
		spaceBetween: 40,
		speed: 400,
		autoHeight: true,
		modules: [Navigation],
		navigation: {
			prevEl: '.capabilities-prev',
			nextEl: '.capabilities-next',
		},
		breakpoints: {
			0: {
				allowTouchMove: false,
			},
			501: {
				allowTouchMove: true,
			},
		},
	});

	const cardSwiperEls = document.querySelectorAll(
		'.capabilities-cards-swiper',
	);
	const cardSwipers = [];

	cardSwiperEls.forEach((el) => {
		const paginationEl = el.querySelector('.capabilities-cards-pagination');
		const swiper = new Swiper(el, {
			modules: [Pagination],
			slideClass: 'capability-card',
			nested: true,
			slidesPerView: 2,
			slidesPerGroup: 2,
			spaceBetween: 12,
			observer: true,
			observeParents: true,
			pagination: {
				el: paginationEl,
				clickable: true,
			},
			breakpoints: {
				501: {
					enabled: false,
				},
				0: {
					enabled: true,
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 12,
				},
			},
		});

		swiper.on('slideChange', () => {
			contentSwiper.updateAutoHeight();
		});

		cardSwipers.push(swiper);
	});

	navTabs.forEach((tab, index) => {
		tab.addEventListener('click', () => {
			contentSwiper.slideTo(index);
			navSwiper.slideTo(index);
			updateActiveTab(index);
			if (cardSwipers[index]) {
				cardSwipers[index].slideTo(0, 0);
				cardSwipers[index].update();
			}
		});
	});

	contentSwiper.on('slideChange', () => {
		const activeIndex = contentSwiper.activeIndex;
		navSwiper.slideTo(activeIndex);
		updateActiveTab(activeIndex);
		if (cardSwipers[activeIndex]) {
			cardSwipers[activeIndex].slideTo(0, 0);
			cardSwipers[activeIndex].update();
		}
		setTimeout(() => {
			contentSwiper.updateAutoHeight();
		}, 50);
	});

	window.addEventListener('resize', () => {
		cardSwipers.forEach((s) => s.update());
		contentSwiper.update();
		contentSwiper.updateAutoHeight();
		navSwiper.update();
	});

	function updateActiveTab(index) {
		navTabs.forEach((t, i) => {
			if (i === index) {
				t.classList.add('active-tab');
			} else {
				t.classList.remove('active-tab');
			}
		});
	}
};

window.addEventListener('load', () => {
	initCapabilitiesSwiper();
	initAgile();
	// bestPractices();
	rightChoice();

	// Allow DOM, swipers & layouts to settle, then refresh ScrollTrigger
	setTimeout(() => {
		ScrollTrigger.refresh();
	}, 150);

	// Refresh when web fonts finish rendering (avoids text-reflow layout shifts)
	if (document.fonts) {
		document.fonts.ready.then(() => {
			ScrollTrigger.refresh();
		});
	}
});

let resizeTimer;
window.addEventListener('resize', () => {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 300);
});

//#region Choice Section
function rightChoice() {
	const target = document.querySelector('.cyntexa-right-choice');
	if (!target) return;

	let isStatsVisilble = false;
	function handleIntersection(entries) {
		entries.map((entry) => {
			if (entry.isIntersecting) {
				if (!isStatsVisilble) {
					isStatsVisilble = true;
					document
						.querySelectorAll('.stats')
						.forEach(function (element) {
							var countTo = parseInt(
								element.getAttribute('data-stats'),
							);
							var countNum = parseInt(element.textContent);

							var duration = 3000;
							var startTime = null;

							function animate(timestamp) {
								if (!startTime) startTime = timestamp;
								var progress = timestamp - startTime;
								var increment = (countTo / duration) * progress;

								if (progress < duration) {
									element.textContent = Math.floor(
										countNum + increment,
									);
									requestAnimationFrame(animate);
								} else {
									element.textContent = countTo;
								}
							}

							requestAnimationFrame(animate);
						});
				}
			}
		});
	}
	const observer = new IntersectionObserver(handleIntersection);

	observer.observe(target);

	let sections = gsap.utils.toArray('.cyntexa-right-choice .box');
	let boxes = document.querySelector('.cyntexa-right-choice .boxes');
	if (!boxes || !sections.length) return;

	gsap.matchMedia().add('(min-width: 65.625em)', () => {
		let rightChoice = gsap.timeline({
			scrollTrigger: {
				trigger: '.cyntexa-right-choice',
				start: 'center center',
				end: () => '+=' + boxes.offsetWidth,
				scrub: true,
				pin: '.cyntexa-right-choice',
				pinSpacing: true,
				anticipatePin: 1,
				invalidateOnRefresh: true,
			},
		});

		rightChoice.to(
			sections,
			{
				duration: 3,
				xPercent: -70 * sections.length,
			},
			'>',
		);
	});

	gsap.matchMedia().add('(max-width: 65.625em)', () => {
		let rightChoice = gsap.timeline({
			scrollTrigger: {
				trigger: '.cyntexa-right-choice',
				start: 'center-=30px center',
				end: () => '+=' + boxes.offsetWidth,
				scrub: true,
				pin: '.cyntexa-right-choice',
				pinSpacing: true,
				anticipatePin: 1,
				invalidateOnRefresh: true,
			},
		});

		rightChoice.to(
			sections,
			{
				duration: 3,
				xPercent: -100 * (sections.length - 1),
			},
			'>',
		);
	});
}

const initSwiperWhenVisible = (selector, options) => {
	const el = document.querySelector(selector);
	if (!el) return;

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					new Swiper(selector, options);
					obs.unobserve(entry.target);
				}
			});
		},
		{ rootMargin: '200px' },
	);

	observer.observe(el);
};

initSwiperWhenVisible('.deep-dive-section-slider', {
	modules: [Autoplay, Navigation],
	loop: true,
	autoplay: {
		delay: 2000,
	},
	slidesPerView: 3,
	spaceBetween: 100,
	navigation: {
		nextEl: '.deep-dive-section .swiper-button-next',
		prevEl: '.deep-dive-section .swiper-button-prev',
	},
	breakpoints: {
		320: {
			slidesPerView: 1,
			spaceBetween: 100,
		},
		600: {
			slidesPerView: 2,
			spaceBetween: 40,
		},
		1000: {
			slidesPerView: 3,
			spaceBetween: 60,
		},
		1200: {
			slidesPerView: 3,
			spaceBetween: 100,
		},
	},
});

//faq section js code
const BindEvent = () => {
	let faq_question = document.getElementsByClassName('faq-question');
	let hiddenFaqs = document.querySelectorAll('.hidden-faq');
	let viewAllFaqBtn = document.querySelector('.faq-view-btn');
	for (let i = 0; i < faq_question.length; i++) {
		const question = faq_question[i];
		question.addEventListener('click', function (e) {
			let all_faq = document.getElementsByClassName('faq');
			let isopen =
				e.currentTarget.parentNode.classList.contains('active');
			for (let index = 0; index < all_faq.length; index++) {
				all_faq[index].classList.remove('active');
			}
			if (isopen === false) {
				e.currentTarget.parentNode.classList.add('active');
			}
		});
	}

	viewAllFaqBtn.addEventListener('click', () => {
		if (!viewAllFaqBtn.classList.contains('active')) {
			viewAllFaqBtn.textContent = 'View Less';
			viewAllFaqBtn.classList.add('active');
			hiddenFaqs.forEach((hiddenFaq) => {
				hiddenFaq.style.display = 'flex';
			});
		} else {
			viewAllFaqBtn.textContent = 'View All';
			viewAllFaqBtn.classList.remove('active');
			hiddenFaqs.forEach((hiddenFaq) => {
				hiddenFaq.style.display = 'none';
			});
		}
	});
};
BindEvent();
